import { render, staticRenderFns } from "./ResultGame.vue?vue&type=template&id=0a28a720"
import script from "./ResultGame.vue?vue&type=script&lang=js"
export * from "./ResultGame.vue?vue&type=script&lang=js"
import style0 from "./ResultGame.vue?vue&type=style&index=0&id=0a28a720&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports